/* =========================================================
   Squishy Pop – squishy 3D modelable (WebGL pur, sans bibliothèque)
   - Seul le squishy bouge : le décor, l'affiche et la scène restent immobiles
   - Appuyer / glisser sur le squishy : on le modèle, il garde l'empreinte puis remonte lentement
   - Mode « sur l'affiche » : si une image découpée 3d-… a la même taille que l'affiche,
     l'affiche reste fixe et seul le squishy dessus se déforme, à sa place
   - Flèches / points : produit suivant
   ========================================================= */
(function () {
  'use strict';
  var G = 128;              // finesse du maillage
  var S = 512;              // résolution d'analyse de l'image
  var DEPTH = 0.58;         // épaisseur du squishy
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Petite algèbre 4x4 (colonnes) ---------- */
  function mul(a, b) {
    var o = new Float32Array(16);
    for (var c = 0; c < 4; c++) for (var r = 0; r < 4; r++) {
      o[c * 4 + r] = a[r] * b[c * 4] + a[4 + r] * b[c * 4 + 1] + a[8 + r] * b[c * 4 + 2] + a[12 + r] * b[c * 4 + 3];
    }
    return o;
  }
  function persp(fov, asp, n, f) {
    var t = 1 / Math.tan(fov / 2), o = new Float32Array(16);
    o[0] = t / asp; o[5] = t; o[10] = (f + n) / (n - f); o[11] = -1; o[14] = 2 * f * n / (n - f); return o;
  }
  function ident() { var o = new Float32Array(16); o[0] = o[5] = o[10] = o[15] = 1; return o; }
  function trans(x, y, z) { var o = ident(); o[12] = x; o[13] = y; o[14] = z; return o; }
  function rotX(a) { var o = ident(), c = Math.cos(a), s = Math.sin(a); o[5] = c; o[6] = s; o[9] = -s; o[10] = c; return o; }
  function rotY(a) { var o = ident(), c = Math.cos(a), s = Math.sin(a); o[0] = c; o[2] = -s; o[8] = s; o[10] = c; return o; }
  function scale(x, y, z) { var o = ident(); o[0] = x; o[5] = y; o[10] = z; return o; }

  /* ---------- Analyse de la photo : détourage + relief ---------- */
  function analyse(img) {
    var c = document.createElement('canvas'); c.width = c.height = S;
    var x = c.getContext('2d', { willReadFrequently: true });
    var w = img.naturalWidth || img.width, h = img.naturalHeight || img.height, sc = S / Math.max(w, h);
    var dw = Math.round(w * sc), dh = Math.round(h * sc), ox = (S - dw) >> 1, oy = (S - dh) >> 1;
    x.drawImage(img, ox, oy, dw, dh);
    var id; try { id = x.getImageData(0, 0, S, S); } catch (e) { return null; }
    var p = id.data, n = S * S, k, i, j;

    // 1. Fond transparent ? sinon fond clair relié aux bords
    var transp = 0, area = 0;
    for (j = oy; j < oy + dh; j += 2) for (i = ox; i < ox + dw; i += 2) { area++; if (p[(j * S + i) * 4 + 3] < 128) transp++; }
    var bg = new Uint8Array(n);
    if (transp / area > 0.02) {
      for (k = 0; k < n; k++) bg[k] = p[k * 4 + 3] < 110 ? 1 : 0;
    } else {
      // Fond blanc relié aux bords
      var isBg = function (k) {
        if (p[k * 4 + 3] < 110) return true;
        var r = p[k * 4], g = p[k * 4 + 1], b = p[k * 4 + 2];
        return r > 222 && g > 222 && b > 222 && Math.max(r, g, b) - Math.min(r, g, b) < 26;
      };
      var q = new Int32Array(n), qh = 0, qt = 0;
      for (i = 0; i < S; i++) { [i, (S - 1) * S + i, i * S, i * S + S - 1].forEach(function (k) { if (!bg[k] && isBg(k)) { bg[k] = 1; q[qt++] = k; } }); }
      while (qh < qt) {
        k = q[qh++]; var cx = k % S, cy = (k / S) | 0;
        if (cx > 0 && !bg[k - 1] && isBg(k - 1)) { bg[k - 1] = 1; q[qt++] = k - 1; }
        if (cx < S - 1 && !bg[k + 1] && isBg(k + 1)) { bg[k + 1] = 1; q[qt++] = k + 1; }
        if (cy > 0 && !bg[k - S] && isBg(k - S)) { bg[k - S] = 1; q[qt++] = k - S; }
        if (cy < S - 1 && !bg[k + S] && isBg(k + S)) { bg[k + S] = 1; q[qt++] = k + S; }
      }
      // Fond coloré (pas de blanc autour) : toute la photo devient un coussin aux coins arrondis
      var inDrawn = 0, bgDrawn = 0;
      for (j = oy; j < oy + dh; j += 2) for (i = ox; i < ox + dw; i += 2) { inDrawn++; if (bg[j * S + i]) bgDrawn++; }
      if (bgDrawn / inDrawn < 0.08) {
        var rad = Math.min(dw, dh) * 0.2;
        for (j = 0; j < S; j++) for (i = 0; i < S; i++) {
          k = j * S + i;
          var qx = Math.max(ox + rad - i, 0, i - (ox + dw - 1 - rad)), qy = Math.max(oy + rad - j, 0, j - (oy + dh - 1 - rad));
          bg[k] = (i < ox || i >= ox + dw || j < oy || j >= oy + dh || qx * qx + qy * qy > rad * rad) ? 1 : 0;
        }
      }
    }
    // 2. On garde la plus grosse forme (enlève textes et petits morceaux)
    var lab = new Int32Array(n), best = 0, bestSize = 0, cur = 0, st = new Int32Array(n);
    for (k = 0; k < n; k++) {
      if (bg[k] || lab[k]) continue;
      cur++; var size = 0, sp = 0; st[sp++] = k; lab[k] = cur;
      while (sp) {
        var m = st[--sp]; size++; var mx = m % S, my = (m / S) | 0;
        if (mx > 0 && !bg[m - 1] && !lab[m - 1]) { lab[m - 1] = cur; st[sp++] = m - 1; }
        if (mx < S - 1 && !bg[m + 1] && !lab[m + 1]) { lab[m + 1] = cur; st[sp++] = m + 1; }
        if (my > 0 && !bg[m - S] && !lab[m - S]) { lab[m - S] = cur; st[sp++] = m - S; }
        if (my < S - 1 && !bg[m + S] && !lab[m + S]) { lab[m + S] = cur; st[sp++] = m + S; }
      }
      if (size > bestSize) { bestSize = size; best = cur; }
    }
    if (bestSize < n * 0.01) { best = -1; }
    // 3. Cadrage serré sur le produit
    var x0 = S, y0 = S, x1 = 0, y1 = 0;
    for (k = 0; k < n; k++) {
      var inside = best === -1 ? !bg[k] : lab[k] === best;
      p[k * 4 + 3] = inside ? 255 : 0;
      if (inside) { var px = k % S, py = (k / S) | 0; if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py; }
    }
    if (x1 <= x0 || y1 <= y0) { x0 = 0; y0 = 0; x1 = S - 1; y1 = S - 1; }
    x.putImageData(id, 0, 0);
    var bw = x1 - x0 + 1, bh = y1 - y0 + 1, side = Math.max(bw, bh) * 1.06;
    var t = document.createElement('canvas'); t.width = t.height = S;
    var tx = t.getContext('2d', { willReadFrequently: true });
    var s2 = S / side;
    if ('filter' in tx) tx.filter = 'blur(0.8px)';
    tx.drawImage(c, x0, y0, bw, bh, (S - bw * s2) / 2, (S - bh * s2) / 2, bw * s2, bh * s2);
    if ('filter' in tx) tx.filter = 'none';
    var td = tx.getImageData(0, 0, S, S).data;
    // 4. Carte de distance au bord → relief arrondi
    var INF = 1e9, d = new Float32Array(n);
    for (k = 0; k < n; k++) d[k] = td[k * 4 + 3] > 127 ? INF : 0;
    for (j = 0; j < S; j++) for (i = 0; i < S; i++) {
      k = j * S + i; if (!d[k]) continue;
      var v = d[k];
      if (i > 0) v = Math.min(v, d[k - 1] + 1);
      if (j > 0) v = Math.min(v, d[k - S] + 1, i > 0 ? d[k - S - 1] + 1.414 : INF, i < S - 1 ? d[k - S + 1] + 1.414 : INF);
      else v = Math.min(v, 1);
      if (i === 0 || i === S - 1 || j === 0) v = Math.min(v, 1);
      d[k] = v;
    }
    for (j = S - 1; j >= 0; j--) for (i = S - 1; i >= 0; i--) {
      k = j * S + i; if (!d[k]) continue;
      var u = d[k];
      if (i < S - 1) u = Math.min(u, d[k + 1] + 1);
      if (j < S - 1) u = Math.min(u, d[k + S] + 1, i < S - 1 ? d[k + S + 1] + 1.414 : INF, i > 0 ? d[k + S - 1] + 1.414 : INF);
      else u = Math.min(u, 1);
      d[k] = u;
    }
    var dmax = 1; for (k = 0; k < n; k++) if (d[k] > dmax) dmax = d[k];
    var H = new Float32Array((G + 1) * (G + 1));
    for (j = 0; j <= G; j++) for (i = 0; i <= G; i++) {
      var sx = Math.min(S - 1, Math.round(i / G * (S - 1))), sy = Math.min(S - 1, Math.round((1 - j / G) * (S - 1)));
      var tt = Math.min(1, d[sy * S + sx] / (dmax * 0.8));
      H[j * (G + 1) + i] = tt > 0 ? 0.06 + 0.94 * (tt * (2 - tt)) * (0.75 + 0.25 * Math.sqrt(tt)) : 0;
    }
    // 5. Lissage du relief (enlève les arêtes « en pyramide », donne un bombé de coussin)
    var N1 = G + 1, H2 = new Float32Array(H.length);
    for (var it = 0; it < 14; it++) {
      for (j = 0; j <= G; j++) for (i = 0; i <= G; i++) {
        k = j * N1 + i;
        if (!H[k]) { H2[k] = 0; continue; }
        var sum = H[k] * 2, cnt = 2;
        if (i > 0) { sum += H[k - 1]; cnt++; } if (i < G) { sum += H[k + 1]; cnt++; }
        if (j > 0) { sum += H[k - N1]; cnt++; } if (j < G) { sum += H[k + N1]; cnt++; }
        H2[k] = Math.max(0.04, sum / cnt);
      }
      var tmp = H; H = H2; H2 = tmp;
    }
    var hm = 0; for (k = 0; k < H.length; k++) if (H[k] > hm) hm = H[k];
    if (hm > 0) for (k = 0; k < H.length; k++) if (H[k]) H[k] = Math.min(1, H[k] / hm);
    return { canvas: t, H: H, cx: x0 + bw / 2, cy: y0 + bh / 2, side: side };
  }

  /* ---------- Shaders ---------- */
  var VS = 'attribute vec3 a_pos;attribute vec3 a_nrm;attribute vec2 a_uv;uniform mat4 u_mvp;uniform mat4 u_model;varying vec3 v_n;varying vec2 v_uv;varying vec3 v_p;' +
    'void main(){gl_Position=u_mvp*vec4(a_pos,1.0);v_n=mat3(u_model)*a_nrm;v_uv=a_uv;v_p=(u_model*vec4(a_pos,1.0)).xyz;}';
  var FS = 'precision mediump float;uniform sampler2D u_tex;uniform float u_back;uniform vec3 u_cam;varying vec3 v_n;varying vec2 v_uv;varying vec3 v_p;' +
    'void main(){vec4 c=texture2D(u_tex,v_uv);if(c.a<0.5)discard;vec3 n=normalize(v_n);' +
    'vec3 L1=normalize(vec3(0.45,0.8,1.0));vec3 L2=normalize(vec3(-0.9,-0.35,0.45));vec3 V=normalize(u_cam-v_p);' +
    'float d=max(dot(n,L1),0.0)*0.78+max(dot(n,L2),0.0)*0.22;' +
    'float s=pow(max(dot(n,normalize(L1+V)),0.0),46.0)*0.5;' +
    'float rim=pow(1.0-max(dot(n,V),0.0),3.0)*0.22;' +
    'vec3 col=c.rgb*(0.5+0.62*d)+vec3(s+rim);if(u_back>0.5)col*=0.84;gl_FragColor=vec4(col,1.0);}';

  function compile(gl, type, src) { var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s)); return s; }

  /* ---------- Visualiseur ---------- */
  function Viewer(root) {
    var self = this;
    this.root = root;
    this.canvas = root.querySelector('canvas');
    var gl = this.canvas.getContext('webgl', { antialias: true, alpha: true, premultipliedAlpha: true }) || this.canvas.getContext('experimental-webgl', { antialias: true, alpha: true });
    if (!gl) throw new Error('webgl');
    this.gl = gl;
    var pr = gl.createProgram();
    gl.attachShader(pr, compile(gl, gl.VERTEX_SHADER, VS)); gl.attachShader(pr, compile(gl, gl.FRAGMENT_SHADER, FS));
    gl.linkProgram(pr); if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw new Error('link');
    gl.useProgram(pr); this.pr = pr;
    this.loc = {
      pos: gl.getAttribLocation(pr, 'a_pos'), nrm: gl.getAttribLocation(pr, 'a_nrm'), uv: gl.getAttribLocation(pr, 'a_uv'),
      mvp: gl.getUniformLocation(pr, 'u_mvp'), model: gl.getUniformLocation(pr, 'u_model'),
      back: gl.getUniformLocation(pr, 'u_back'), cam: gl.getUniformLocation(pr, 'u_cam'), tex: gl.getUniformLocation(pr, 'u_tex')
    };
    var V = (G + 1) * (G + 1);
    // UV + indices (communs)
    var uv = new Float32Array(V * 2), idx = new Uint16Array(G * G * 6), q = 0;
    for (var j = 0; j <= G; j++) for (var i = 0; i <= G; i++) { uv[(j * (G + 1) + i) * 2] = i / G; uv[(j * (G + 1) + i) * 2 + 1] = j / G; }
    for (j = 0; j < G; j++) for (i = 0; i < G; i++) {
      var a = j * (G + 1) + i, b = a + 1, c = a + G + 1, d = c + 1;
      idx[q++] = a; idx[q++] = b; idx[q++] = d; idx[q++] = a; idx[q++] = d; idx[q++] = c;
    }
    this.uvBuf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuf); gl.bufferData(gl.ARRAY_BUFFER, uv, gl.STATIC_DRAW);
    this.idxBuf = gl.createBuffer(); gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.idxBuf); gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, idx, gl.STATIC_DRAW);
    this.count = idx.length;
    this.sides = [0, 1].map(function () {
      var s = { pos: new Float32Array(V * 3), nrm: new Float32Array(V * 3), pb: gl.createBuffer(), nb: gl.createBuffer() };
      gl.bindBuffer(gl.ARRAY_BUFFER, s.pb); gl.bufferData(gl.ARRAY_BUFFER, s.pos.byteLength, gl.DYNAMIC_DRAW);
      gl.bindBuffer(gl.ARRAY_BUFFER, s.nb); gl.bufferData(gl.ARRAY_BUFFER, s.nrm.byteLength, gl.DYNAMIC_DRAW);
      return s;
    });
    this.tex = gl.createTexture();
    gl.enable(gl.DEPTH_TEST);
    gl.clearColor(0, 0, 0, 0);

    // état physique
    this.H = null; this.dirty = true;
    this.D = new Float32Array(V); this.dmax = 0;       // empreintes du doigt (0 → 1)
    this.press = 0; this.pressV = 0; this.pressing = false; this.px = 0; this.py = 0; this.tpx = 0; this.tpy = 0;
    this.rx = 0; this.ry = 0; this.vry = 0; this.vrx = 0; this.dragging = false; this.lastInteract = -1e9;
    this.pop = 1; this.popV = 0; this.t = 0; this.visible = true;
    this.resize();
    if ('ResizeObserver' in window) new ResizeObserver(function () { self.resize(); }).observe(this.canvas);
    this.bind();
    var loop = function (ts) {
      var dt = Math.min(0.033, (ts - (self.lastTs || ts)) / 1000); self.lastTs = ts;
      if (self.visible && !document.hidden) self.frame(dt);
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; }).observe(root);
  }

  Viewer.prototype.resize = function () {
    var r = this.canvas.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
    this.canvas.width = Math.max(2, Math.round(r.width * dpr)); this.canvas.height = Math.max(2, Math.round(r.height * dpr));
    this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    this.aspect = r.width / Math.max(1, r.height);
  };

  Viewer.prototype.setProduct = function (data) {
    var gl = this.gl;
    gl.bindTexture(gl.TEXTURE_2D, this.tex);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, data.canvas);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    this.H = data.H; this.dirty = true; this.D.fill(0); this.dmax = 0;
    this.inplace = !!data.inplace; this.crop = data;
    this.rx = 0; this.ry = 0; this.vrx = 0; this.vry = 0;
    this.pop = reduce ? 1 : 0.15; this.popV = 0;
  };

  // Empreinte du doigt : creuse la mousse autour du point touché
  Viewer.prototype.sculpt = function (x, y, amount) {
    var N = G + 1, D = this.D, R = 0.3, r2 = 2 * 0.16 * 0.16;
    var i0 = Math.max(0, Math.floor((x - R + 1) / 2 * G)), i1 = Math.min(G, Math.ceil((x + R + 1) / 2 * G));
    var j0 = Math.max(0, Math.floor((y - R + 1) / 2 * G)), j1 = Math.min(G, Math.ceil((y + R + 1) / 2 * G));
    for (var j = j0; j <= j1; j++) for (var i = i0; i <= i1; i++) {
      var dx = i / G * 2 - 1 - x, dy = j / G * 2 - 1 - y, f = Math.exp(-(dx * dx + dy * dy) / r2) * amount;
      var k = j * N + i; D[k] = Math.min(1, D[k] + f * (1 - D[k]));
      if (D[k] > this.dmax) this.dmax = D[k];
    }
  };

  // Déformation : empreintes + enfoncement local + renflement + aplatissement global
  Viewer.prototype.build = function () {
    var H = this.H, D = this.D, N = G + 1, pa = this.press, px = this.px, py = this.py, sig2 = 2 * 0.42 * 0.42;
    var spread = 1 + this.dmax * 0.05, depth = DEPTH * (this.inplace ? 0.45 : 1);
    for (var side = 0; side < 2; side++) {
      var s = this.sides[side], P = s.pos, Nn = s.nrm, sign = side ? -1 : 1, dent = side ? 0.3 : 0.85, mold = side ? 0.25 : 0.82;
      for (var j = 0; j < N; j++) for (var i = 0; i < N; i++) {
        var k = j * N + i, h = H[k];
        var bx = i / G * 2 - 1, by = j / G * 2 - 1;
        var dx = bx - px, dy = by - py, f = pa ? Math.exp(-(dx * dx + dy * dy) / sig2) : 0;
        var z = sign * h * depth * (1 - pa * dent * f) * (1 - pa * 0.22) * (1 - mold * D[k]);
        var len = Math.sqrt(dx * dx + dy * dy) + 1e-4, bulge = pa * f * 0.08 * h;
        if (this.inplace) {
          P[k * 3] = bx * (1 + pa * 0.07) * spread + dx / len * bulge;
          P[k * 3 + 1] = by * (1 + pa * 0.03) * spread + dy / len * bulge;
        } else {
          P[k * 3] = bx * (1 + pa * 0.1) * spread + dx / len * bulge;
          P[k * 3 + 1] = ((by + 1) * (1 - pa * 0.1) - 1) * spread + dy / len * bulge;
        }
        P[k * 3 + 2] = z;
      }
      // normales par différences finies
      for (j = 0; j < N; j++) for (i = 0; i < N; i++) {
        k = j * N + i;
        var l = j * N + Math.max(0, i - 1), r = j * N + Math.min(G, i + 1), dn = Math.max(0, j - 1) * N + i, up = Math.min(G, j + 1) * N + i;
        var fx = (P[r * 3 + 2] - P[l * 3 + 2]) / ((P[r * 3] - P[l * 3]) || 1e-3);
        var fy = (P[up * 3 + 2] - P[dn * 3 + 2]) / ((P[up * 3 + 1] - P[dn * 3 + 1]) || 1e-3);
        var nx = side ? fx : -fx, ny = side ? fy : -fy, nz = side ? -1 : 1, il = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
        Nn[k * 3] = nx * il; Nn[k * 3 + 1] = ny * il; Nn[k * 3 + 2] = nz * il;
      }
      var gl = this.gl;
      gl.bindBuffer(gl.ARRAY_BUFFER, s.pb); gl.bufferSubData(gl.ARRAY_BUFFER, 0, P);
      gl.bindBuffer(gl.ARRAY_BUFFER, s.nb); gl.bufferSubData(gl.ARRAY_BUFFER, 0, Nn);
    }
  };

  Viewer.prototype.model = function () {
    var p = this.pop;
    if (this.inplace) {
      var c = this.crop, sc = c.side / S;
      return mul(trans(c.cx / S * 2 - 1, 1 - c.cy / S * 2, 0), mul(scale(sc * p, sc * p, sc * p), mul(rotY(this.ry), rotX(this.rx))));
    }
    return mul(trans(0, -0.04, 0), mul(rotY(this.ry), mul(rotX(this.rx), scale(p, p, p))));
  };

  Viewer.prototype.frame = function (dt) {
    this.t += dt;
    // ressort de pression
    var f = 230 * ((this.pressing ? 0.55 : 0) - this.press) - 9 * this.pressV;
    this.pressV += f * dt; this.press += this.pressV * dt;
    if (this.press < -0.25) this.press = -0.25;
    this.px += (this.tpx - this.px) * Math.min(1, dt * 18); this.py += (this.tpy - this.py) * Math.min(1, dt * 18);
    // apparition (pop gélatineux)
    var pf = 160 * (1 - this.pop) - 9 * this.popV; this.popV += pf * dt; this.pop += this.popV * dt;
    // rotation : inertie, puis balancement doux
    var tiltX = 0, tiltY = 0;
    if (this.pressing && !reduce) { tiltY = this.px * 0.22; tiltX = -this.py * 0.22; }
    var kf = Math.min(1, dt * 7);
    this.ry += (tiltY - this.ry) * kf; this.rx += (tiltX - this.rx) * kf;
    if (!this.H) return;
    var molding = false;
    if (this.pressing) { this.sculpt(this.px, this.py, Math.min(1, dt * 3.2)); molding = true; }
    if (this.dmax > 0.002) {
      var keep = Math.exp(-dt / (this.pressing ? 6 : 1.9)), D = this.D, m = 0;   // remontée lente (~2 s)
      for (var k = 0; k < D.length; k++) { if (D[k]) { D[k] *= keep; if (D[k] < 0.002) D[k] = 0; else if (D[k] > m) m = D[k]; } }
      this.dmax = m; molding = true;
    }
    if (this.dirty || molding || Math.abs(this.press) > 0.0008 || Math.abs(this.pressV) > 0.001) { this.build(); this.dirty = false; }
    var gl = this.gl, L = this.loc;
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    var M = this.model(), P, Vw;
    if (this.inplace) { P = ident(); P[10] = -1; Vw = ident(); }
    else { P = persp(30 * Math.PI / 180, this.aspect, 0.1, 50); Vw = trans(0, 0, -5.4); }
    this.M = M; this.P = P;
    gl.uniformMatrix4fv(L.mvp, false, mul(P, mul(Vw, M)));
    gl.uniformMatrix4fv(L.model, false, M);
    gl.uniform3f(L.cam, 0, 0, 5.4);
    gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, this.tex); gl.uniform1i(L.tex, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, this.uvBuf); gl.enableVertexAttribArray(L.uv); gl.vertexAttribPointer(L.uv, 2, gl.FLOAT, false, 0, 0);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.idxBuf);
    for (var side = 0; side < 2; side++) {
      var s = this.sides[side];
      gl.uniform1f(L.back, side);
      gl.bindBuffer(gl.ARRAY_BUFFER, s.pb); gl.enableVertexAttribArray(L.pos); gl.vertexAttribPointer(L.pos, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, s.nb); gl.enableVertexAttribArray(L.nrm); gl.vertexAttribPointer(L.nrm, 3, gl.FLOAT, false, 0, 0);
      gl.drawElements(gl.TRIANGLES, this.count, gl.UNSIGNED_SHORT, 0);
    }
    if (this.onFrame) this.onFrame(this.press, this.pop);
  };

  // Rayon souris → point touché sur le squishy (plan z = 0 de l'objet)
  Viewer.prototype.pick = function (cx, cy) {
    if (!this.M || !this.H) return null;
    var r = this.canvas.getBoundingClientRect();
    if (this.inplace) {
      var c = this.crop, X = (cx - r.left) / r.width * S, Y = (cy - r.top) / r.height * S;
      var ux = (X - c.cx) / (c.side / 2), uy = (c.cy - Y) / (c.side / 2);
      if (ux < -1 || ux > 1 || uy < -1 || uy > 1) return null;
      var ii = Math.round((ux + 1) / 2 * G), jj = Math.round((uy + 1) / 2 * G);
      return this.H[jj * (G + 1) + ii] > 0.02 ? [ux, uy] : null;
    }
    var nx = ((cx - r.left) / r.width) * 2 - 1, ny = 1 - ((cy - r.top) / r.height) * 2;
    var tf = Math.tan(15 * Math.PI / 180);
    var dir = [nx * tf * this.aspect, ny * tf, -1], org = [0, 0, 5.4];
    var M = this.M, s = this.pop || 1;
    // inverse : M = T · R (rotation pure) · S
    var o = [org[0] - M[12], org[1] - M[13], org[2] - M[14]];
    function rt(v) { return [(M[0] * v[0] + M[1] * v[1] + M[2] * v[2]) / (s * s), (M[4] * v[0] + M[5] * v[1] + M[6] * v[2]) / (s * s), (M[8] * v[0] + M[9] * v[1] + M[10] * v[2]) / (s * s)]; }
    var lo = rt(o), ld = rt(dir);
    if (Math.abs(ld[2]) < 1e-5) return null;
    var t = -lo[2] / ld[2], hx = lo[0] + ld[0] * t, hy = lo[1] + ld[1] * t;
    if (hx < -1 || hx > 1 || hy < -1 || hy > 1) return null;
    var i = Math.round((hx + 1) / 2 * G), j = Math.round((hy + 1) / 2 * G);
    return this.H[j * (G + 1) + i] > 0.02 ? [hx, hy] : null;
  };

  Viewer.prototype.bind = function () {
    var self = this, c = this.canvas, lx = 0, ly = 0, sx = 0, lt = 0;
    c.addEventListener('pointerdown', function (e) {
      self.dragging = true; self.lastInteract = self.t; lx = sx = e.clientX; ly = e.clientY; lt = performance.now();
      self.vry = self.vrx = 0;
      try { c.setPointerCapture(e.pointerId); } catch (err) {}
      var hit = self.pick(e.clientX, e.clientY);
      self.mode = hit ? 'mold' : 'turn';
      if (hit) {
        self.pressing = true; self.tpx = self.px = hit[0]; self.tpy = self.py = hit[1];
        self.root.classList.add('is-pressing');
        if (self.onPress) self.onPress(e.clientX, e.clientY);
      }
    });
    c.addEventListener('pointermove', function (e) {
      if (!self.dragging) return;
      var now = performance.now(), dx = e.clientX - lx, dy = e.clientY - ly, dtm = Math.max(8, now - lt);
      if (self.mode === 'mold') {
        var hit = self.pick(e.clientX, e.clientY);
        if (hit) { self.tpx = hit[0]; self.tpy = hit[1]; self.sculpt(hit[0], hit[1], 0.18); }
      }
      lx = e.clientX; ly = e.clientY; lt = now; self.lastInteract = self.t;
    });
    var end = function (e) {
      if (!self.dragging) return;
      self.dragging = false; self.pressing = false; self.root.classList.remove('is-pressing');
      self.lastInteract = self.t;
      if (self.mode === 'turn' && self.onSwipe && Math.abs(e.clientX - sx) > 90) self.onSwipe(e.clientX < sx ? 1 : -1);
    };
    c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end); c.addEventListener('lostpointercapture', end);
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var jx = (Math.random() - 0.5) * 0.6, jy = (Math.random() - 0.5) * 0.6 + 0.1;
        self.tpx = self.px = jx; self.tpy = self.py = jy; self.pressing = true; self.lastInteract = self.t;
        self.sculpt(jx, jy, 0.6);
        setTimeout(function () { self.pressing = false; }, 220);
        if (self.onPress) { var r = c.getBoundingClientRect(); self.onPress(r.left + r.width / 2, r.top + r.height / 2); }
      }
      if (e.key === 'ArrowLeft' && self.onSwipe) self.onSwipe(-1);
      if (e.key === 'ArrowRight' && self.onSwipe) self.onSwipe(1);
    });
  };

  /* ---------- Mise en place sur la page ---------- */
  function loadImage(src) {
    return new Promise(function (res, rej) {
      var im = new Image();
      if (!/^data:/.test(src)) im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }

  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var dataEl = root.querySelector('[data-sq3d-products]') || (root.parentElement && root.parentElement.querySelector('[data-sq3d-products]'));
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!products.length) return;
    var viewer;
    try { viewer = new Viewer(root); } catch (e) { return; }  // pas de WebGL → la photo classique reste affichée

    var wrap = root.closest('[data-sq3d-wrap]') || root.parentElement;
    var tag = wrap.querySelector('[data-sq3d-tag]'), tTitle = wrap.querySelector('[data-sq3d-title]'), tPrice = wrap.querySelector('[data-sq3d-price]');
    var dots = root.querySelector('[data-sq3d-dots]'), shadow = root.querySelector('.sq3d__shadow');
    var bgImg = root.querySelector('.sq3d__bg');
    if (!bgImg && products.some(function (p) { return p.bg; })) { bgImg = document.createElement('img'); bgImg.className = 'sq3d__bg'; bgImg.alt = ''; root.insertBefore(bgImg, root.firstChild); }
    var cache = {}, idx = 0, busy = false;

    if (dots) {
      dots.innerHTML = products.map(function (p, i) { return '<button type="button" aria-label="Voir ' + p.title.replace(/"/g, '&quot;') + '"' + (i ? '' : ' aria-current="true"') + '></button>'; }).join('');
      dots.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) show(Array.prototype.indexOf.call(dots.children, b)); });
    }
    function get(i) {
      if (!cache[i]) cache[i] = loadImage(products[i].img).then(function (im) {
        var a = analyse(im); if (!a) throw new Error('cors');
        a.inplace = !!products[i].bg;
        return a;
      });
      return cache[i];
    }
    function show(i) {
      if (busy) return;
      i = (i + products.length) % products.length; busy = true;
      get(i).then(function (a) {
        idx = i;
        var p = products[i];
        if (bgImg) {
          if (p.bg) { bgImg.src = p.bg; root.classList.add('is-inplace'); } else { bgImg.removeAttribute('src'); root.classList.remove('is-inplace'); }
        }
        viewer.setProduct(a);
        if (tag) tag.href = p.url;
        if (tTitle) tTitle.textContent = p.title;
        if (tPrice) tPrice.textContent = p.price;
        if (dots) Array.prototype.forEach.call(dots.children, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        root.classList.add('is-ready'); wrap.classList.add('is-3d');
        get((i + 1) % products.length).catch(function () {});
      }).catch(function () {
        products.splice(i, 1);  // image illisible : on passe au suivant
        if (products.length) { busy = false; show(i); return; }
      }).then(function () { busy = false; });
    }
    root.querySelector('[data-sq3d-prev]') && root.querySelector('[data-sq3d-prev]').addEventListener('click', function () { show(idx - 1); });
    root.querySelector('[data-sq3d-next]') && root.querySelector('[data-sq3d-next]').addEventListener('click', function () { show(idx + 1); });
    viewer.onSwipe = function (dir) { show(idx + dir); };
    viewer.onPress = function (x, y) {
      var hint = wrap.querySelector('.squish-hint'); if (hint) hint.classList.add('is-gone');
      if (window.SquishyFX && window.SquishyFX.burst) window.SquishyFX.burst(x, y, 9);
    };
    viewer.onFrame = function (press, pop) {
      if (shadow) shadow.style.transform = 'translateX(-50%) scale(' + (pop * (1 + Math.max(0, press) * 0.18)).toFixed(3) + ',' + (pop * (1 - Math.max(0, press) * 0.1)).toFixed(3) + ')';
    };
    if (products.length < 2) root.classList.add('is-single');
    show(0);
  }

  function start(scope) { (scope || document).querySelectorAll('[data-sq3d]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); }); else start();
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  window.SquishyViewer3D = { start: start };
})();
